import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { BsLock } from '@react-icons/all-files/bs/BsLock';
import { BsX } from '@react-icons/all-files/bs/BsX';
import { bind } from '../Utils/Bind';

export interface IImpersonatingAlertProps {
    onClick(): void;
    readonly isImpersonating: boolean;
}

@observer
export class ImpersonatingAlert extends React.Component<IImpersonatingAlertProps> {
    public render() {
        const { isImpersonating, onClick } = this.props;

        if (!isImpersonating || this.dismissed) return null;

        return (
            <div className="impersonation-alert text-center p-2">
                <div className="m-0 d-inline-block p-2">
                    <BsLock /> You are impersonating another user. Any action taken will be completed as that user.{' '}
                    <a onClick={onClick} className="text-primary fw-bold">
                        Logout
                    </a>
                </div>
                <button
                    onClick={this.dismiss}
                    className="btn-close btn-close-white position-absolute"
                    style={{ top: '50%', right: '10px', transform: 'translateY(-50%)' }}
                    aria-label="Dismiss"
                />
            </div>
        );
    }

    @bind
    @action
    private dismiss() {
        this.dismissed = true;
    }

    @observable
    private dismissed = false;
}
